// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	titulo: "Gestores Electorales MX",
	production: false,
	firebase: {
		apiKey: "AIzaSyCfdvduIH84_0ggtlHtrCm3OSFIKTxmbds",
		authDomain: "gestorelectoralmx.firebaseapp.com",
		projectId: "gestorelectoralmx",
		storageBucket: "gestorelectoralmx.appspot.com",
		messagingSenderId: "467251569039",
		appId: "1:467251569039:web:07b907b51516509fbe2bfa",
		measurementId: "G-WC8FJ4PKTV", 
		databaseURL: "https://gestorelectoralmx-default-rtdb.firebaseio.com/",
	},
	googleMaps: "AIzaSyBg1h9qOTfHoMU9xd6Wq3GUvuIdQVSX_qs",
	configuracionAplicacion: {
		portadaPersonalizada: true,
		usoDeLibreria: false
	},
	// url: "http://localhost:5000/gestorelectoralmx/us-central1/app", 
	// api: 'http://localhost:5000/gestorelectoralmx/us-central1/app'
	url: "https://us-central1-gestorelectoralmx.cloudfunctions.net/app", 
	api: 'https://us-central1-gestorelectoralmx.cloudfunctions.net/app'
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.